<template>
  <layout>
    <template slot="header">
      Access rights
    </template>

    <template>
      <div class="mx-4">
        <v-select
          :menu-props="{ bottom: true, offsetY: true }"
          v-model="localEntity.owner"
          label="Owner"
          item-text="name"
          item-value="id"
          :items="rightsList"
          class="mx-0 my-4"
        ></v-select>
        <v-select
          :menu-props="{ bottom: true, offsetY: true }"
          v-model="localEntity.ownerRights"
          label="Owner rights"
          item-text="name"
          item-value="id"
          :items="rightsList"
          class="mx-0 my-4"
        ></v-select>
        <v-select
          :menu-props="{ bottom: true, offsetY: true }"
          v-model="localEntity.group"
          label="Group"
          item-text="name"
          item-value="id"
          :items="rightsList"
          class="mx-0 my-4"
        ></v-select>
        <v-select
          :menu-props="{ bottom: true, offsetY: true }"
          v-model="localEntity.groupRights"
          label="Group rights"
          item-text="name"
          item-value="id"
          :items="rightsList"
          class="mx-0 my-4"
        ></v-select>
        <v-select
          :menu-props="{ bottom: true, offsetY: true }"
          v-model="localEntity.otherRights"
          label="Other rights"
          item-text="name"
          item-value="id"
          :items="rightsList"
          class="mx-0 my-4"
        ></v-select>
      </div>
    </template>

    <template slot="footer">
      <v-spacer />
      <v-btn text :loading="false" @click.stop="close">
        cancel
      </v-btn>
      <v-btn color="primary" text :loading="false" @click.stop="apply">
        save
      </v-btn>
    </template>
  </layout>
</template>

<script>
import Layout from '@/layouts/LayoutPopup';
import { ref } from '@vue/composition-api';
export default {
  name: 'tableAccessRights',
  components: {
    Layout
  },
  setup(props, { emit }) {
    const localEntity = ref({});
    const rightsList = [
      { id: 1, name: 'Edit' },
      { id: 2, name: 'Use' },
      { id: 3, name: 'Read' },
      { id: 4, name: 'None' },
      { id: 5, name: '-Mixed-' }
    ];
    function apply() {
      emit('save');
      close();
    }
    function close() {
      emit('close');
    }
    return {
      close,
      apply,
      rightsList,
      localEntity
    };
  }
};
</script>

<style lang="sass"></style>
